import { init } from "@amplitude/analytics-browser";
import isBrowser from "src/utils/isBrowser";

export const initAmplitude = async (): Promise<void> => {
  if (!isBrowser()) return;

  const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY!;

  init(amplitudeApiKey, {
    autocapture: {
      attribution: true,
      pageViews: false, // We handle this manually
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: true,
    },
  });
};
